import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import _ from "lodash";
import { twMerge } from "tailwind-merge";
import { Dialog as HeadlessDialog, TransitionRoot } from "@headlessui/vue";
import { provide, useAttrs, computed, ref, Ref } from "vue";

export type ProvideSlideover = {
  open: boolean;
  zoom: Ref<boolean>;
  size?: Size;
};

interface SlideoverProps extends ExtractProps<typeof HeadlessDialog> {
  size?: Size;
  open: boolean;
  staticBackdrop?: boolean;
}


const __default__ = {
  inheritAttrs: false,
};

type Size = "sm" | "md" | "lg" | "xl";

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Slideover',
  props: {
    size: { default: "md" },
    open: { type: Boolean, default: false },
    staticBackdrop: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: "close", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { size: Size, open: boolean, staticBackdrop?: boolean }


// eslint-disable-next-line
const { as, onClose, staticBackdrop, size } = props;
const open = computed(() => props.open);

const attrs = useAttrs();
const computedClass = computed(() =>
  twMerge(["relative z-[60]", typeof attrs.class === "string" && attrs.class])
);

const zoom = ref(false);


const handleClose = (value: boolean) => {
  if (!staticBackdrop) {
    onClose && onClose(value);
    emit("close", value);
  } else {
    zoom.value = true;
    setTimeout(() => {
      zoom.value = false;
    }, 300);
  }
};

provide<ProvideSlideover>("slideover", {
  open: open.value,
  zoom: zoom,
  size: size,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    appear: "",
    as: "template",
    show: _unref(open)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(HeadlessDialog), _mergeProps({
        as: _unref(as),
        onClose: _cache[0] || (_cache[0] = 
        (value) => {
          handleClose(value);
        }
      ),
        class: _unref(computedClass)
      }, _unref(_).omit(_unref(attrs), 'class', 'onClose')), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["as", "class"])
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})